import { ApiDefinition } from '../../types/api-definitions';

export interface ApiDefinitionsState {
  apiDefinitions: ApiDefinition[];
  loading: boolean;
  error: string | null;
}

export const initialApiState: ApiDefinitionsState = {
  apiDefinitions: [],
  loading: false,
  error: null,
};
